var number = {
  "format": {
    "separator": ",",
    "delimiter": ".",
    "precision": 3,
    "significant": false,
    "strip_insignificant_zeros": false
  },
  "currency": {
    "format": {
      "format": "%u%n",
      "unit": "$",
      "separator": ".",
      "delimiter": ",",
      "precision": 2,
      "significant": false,
      "strip_insignificant_zeros": false
    }
  },
  "percentage": {
    "format": {
      "delimiter": "",
      "format": "%n%"
    }
  },
  "precision": {
    "format": {
      "delimiter": ","
    }
  },
  "human": {
    "format": {
      "delimiter": "",
      "precision": 3,
      "significant": true,
      "strip_insignificant_zeros": true
    },
    "storage_units": {
      "format": "%n %u",
      "units": {
        "byte": {
          "one": "Byte",
          "other": "Bytes"
        },
        "kb": "KB",
        "mb": "MB",
        "gb": "GB",
        "tb": "TB",
        "pb": "PB",
        "eb": "EB"
      }
    },
    "decimal_units": {
      "format": "%n %u",
      "units": {
        "unit": "",
        "thousand": "Mil",
        "million": "Milhão",
        "billion": "Bilhão",
        "trillion": "Trilhão",
        "quadrillion": "Quatrilião"
      }
    }
  }
};
module.exports = number;